import React from 'react'
import {Link } from 'react-router-dom'

class Page extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {

      var Name = this.props.match.params.page;
      Name = Name.replace(/-/g,' ');

    return (
        <div className="main-container full-width pt-5 mt-5">
            <div className="title-breadcrumb">
                <div className="container">
                    <div className="title-breadcrumb-inner">
                        <header className="entry-header">
                            <h1 className="entry-title">{Name}</h1>
                        </header>
                        <div className="breadcrumbs"><Link to="/">Home</Link><span className="separator">/</span><span>{Name}</span></div>
                    </div>
                </div>

            </div>

            <div className='container'>
                <div className="row">

                    <div className="vc_col-xs-12">
                        <div className="page-content default-page">

                            <article id="post-8436"
                                     className="post-8436 page type-page status-publish hentry">

                                <div className="entry-content">
                                    <div className="vc_row wpb_row vc_row-fluid">
                                        <div className="row-container" style={{/* marginLeft:'25%',*/ marginTop:'25px'}} >
                                           <div className="wpb_column vc_column_container vc_col-sm-2">
                                              <div className="vc_column-inner">
                                                 <div className="wpb_wrapper"></div>
                                              </div>
                                           </div>
                                           <div className="wpb_column vc_column_container vc_col-sm-8">
                                              <div className="vc_column-inner">
                                                 <div className="wpb_wrapper">
                                                    <div className="vc_empty_space" style={{height: '150px'}}><span className="vc_empty_space_inner"></span></div>
                                                    <h2 style={{fontSize: '42px',color:'#dd2121', textAlign: 'center',fontFamily:'Lobster',fontWeight:'400',fontStyle:'normal'}} className="vc_custom_heading">{Name} coming soon</h2>
                                                    <div className="vc_empty_space" style={{height: '150px'}}><span className="vc_empty_space_inner"></span></div>
                                                 </div>
                                              </div>
                                           </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </div>   
                    </div>
                </div>
            </div>
        </div>
    )
    }
}
export default Page;



